import VueScrollTo from 'vue-scrollto';
import { Platform } from 'quasar';

class ElementScrollPlugin {
	private static $scrollToId(vue: any, options: any, id: string) {
		const enable = !Platform.has.touch;
		if (enable) {
			vue.nextTick(() => {
				const element = document.getElementById(id);
				if (element) {
					window.scrollTo(0, 0);
					setTimeout(() => VueScrollTo.scrollTo(element), 300);
				}
			});
		}
	}

	public install(vue: any, options: any) {
		vue.prototype.$scrollToId = (id: string) => ElementScrollPlugin.$scrollToId(vue, options, id);
	}
}

export default new ElementScrollPlugin();
